import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import StyledHeaderSwitch from './StyledHeaderSwitch';
export const HeaderSwitch = ({
  isChecked,
  rightText,
  leftText,
  onToggle
}) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
  component: "div",
  variant: "body2",
  style: {
    letterSpacing: 0
  }
}, /*#__PURE__*/React.createElement(Grid, {
  component: "div",
  container: true,
  alignItems: "center"
}, /*#__PURE__*/React.createElement(Grid, {
  item: true
}, leftText), /*#__PURE__*/React.createElement(Grid, {
  item: true
}, /*#__PURE__*/React.createElement(StyledHeaderSwitch, {
  isChecked: isChecked,
  onToggle: onToggle
})), /*#__PURE__*/React.createElement(Grid, {
  item: true
}, rightText))));
export default HeaderSwitch;